import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';

const API_VERSION = 'v1';

export function getSessionReqObj(): RequestOptions {
  return {
    url: `/comgluuoidc/${API_VERSION}/session-token`,
    method: HTTPVerbs.POST,
    retries: 0,
  };
}
